// extracted by mini-css-extract-plugin
export var socialIcon = "contact-module--socialIcon--ad262";
export var socialsList = "contact-module--socialsList--f6f9f";
export var socialsListItem = "contact-module--socialsListItem--02427";